import SelloTiempoBitacora from "../Components/SelloTiempoBitacora";
import { EnumHallazgoOrigen } from "../../../Utils/Enumeradores/ComunEnum";

export const COLUMNS = [
	{
		Header: 'ID',
		accessor: 'hallazgoId',
	},
	{
		Header: 'Origen',
		accessor: 'origen',
		Cell: ({ row }) => {
			const origen = row.original.origenDescripcion || row.original.origen;
			const origenNormalizado = String(origen || '').trim().toUpperCase();
			const esSic = row.original.origen === EnumHallazgoOrigen.SIC_NS || origenNormalizado === 'SIC' || origenNormalizado === 'SIC NS';
			return (
				<span className={`badge justify-content-center ${esSic ? 'bg-sicns' : 'bg-sice'}`}>
					{origen}
				</span>
			);
		}
	},
	{
		Header: 'Fecha Registro',
		accessor: 'fechaCreacion',
		Cell: ({ row }) => <SelloTiempoBitacora data={row.original.fechaCreacion} />
	},
	{
		Header: 'Fecha Limite Correccion',
		accessor: 'fechaLimiteCorreccion',
		Cell: ({ row }) => <SelloTiempoBitacora data={row.original.fechaLimiteCorreccion} />
	},
	{
		Header: 'Indicador',
		accessor: 'indicadorSigla',
		Cell: ({ row }) => {
			const sigla = row.original.indicadorSigla || '';
			const descripcion = row.original.indicadorDescripcion || '';
			return <span>{sigla}{descripcion ? ` - ${descripcion}` : ''}</span>;
		}
	},
	{
		Header: 'ID BIM',
		accessor: 'idBim',
	},
	{
		Header: 'Elemento',
		accessor: 'elementoDescripcion',
	},
	{
		Header: 'Exigencia',
		accessor: 'exigencia',
		Cell: ({ row }) => <span>{row.original.exigencia || row.original.exigenciaDescripcion || ''}</span>
	},
	{
		Header: 'Problema',
		accessor: 'problemaDescripcion',
	},
];
